<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<style lang="sass">
@import 'component'
</style>

<template lang="pug">
  .container
    .login
      .logo-wrapper
        .logo
          a(href="/")
            img.c-app-logo(src="../../../assets/logo-deliver.svg")
        .ati
          .ati-widget
            iframe(scrolling="no" width="100%" height="80" frameborder="0" src="https://ati.su/widgets/badge/?id=1608942&type=gray")
      .user-guide
        a(href="https://static.deliver.ru/documents/carrier_tutorial.pdf" target="_blank") Инструкция для перевозчиков
      .main-form
        transition(name="fade" mode="out-in")
          router-view
      .support
        .support-title Поддержка 24/7
        a.support-contact(href="tel:+78007777786")
            img(src="../../../assets/phone.svg")
            span 8 (800) 777 77 86
        a.support-contact(href="mailto:vopros@deliver.ru")
            img(src="../../../assets/mail.svg")
            span vopros@deliver.ru
      .info
        .info-advantages
          .info-advantage(v-for="item in advantages") {{ item }}
        //- .info-contacts
          .info-contacts-text В случае возникновения вопросов, просьба обращаться к ответственным менеджерам по регионам загрузки и маршрутам:
          .info-contacts-section
            .info-contacts-block(v-for="(item, i) in contactBlocks")
              .info-contacts-block-region {{ item.region }}
              .info-contacts-block-name {{ item.manager.name }}
              a(:href="`tel:+${item.manager.phone}`")
                .info-contacts-block-phone {{ formatNumber(item.manager.phone) }}
              a(:href="`mailto:${item.manager.email}`")
                .info-contacts-block-email(:class="{'short-length-email': i === 5}") {{ item.manager.email }}
        .footer
          div С уважением, команда Deliver.ru
          a(href="tel:+78007777786") 8-800-777-77-86
</template>

<script>
import { mapGetters } from 'vuex';

import cMask from 'components/c/mask/component';
// import InfoBlockTemplate from './info-block-template';

export default {
  components: {
    cMask,
    // InfoBlockTemplate
  },

  data() {
    return {
      locale: this.$i18n.locale,
      isEnterNumberLinkVisible: false,
      isRegistrationLinkVisible: false,
      isForgotPasswordLinkVisible: true,
      stars: 5,
      advantages: [
        'Предоплата 90% на все рейсы',
        'Гарантии постоянной загрузки до конца года',
        'Быстрая загрузка и выгрузка',
        'Скидка на топливо. Без скрытых платежей.',
      ],
      contactBlocks: [
        {
          region: 'Москва и область – Сибирь',
          manager: {
            name: 'Айгуль Андреева',
            phone: '79251374862',
            email: 'aygul.andreeva@deliver.ru',
          },
        },
        {
          region: 'Московская область – Краснодар',
          manager: {
            name: 'Юлия Фролова',
            phone: '79250075189',
            email: 'julia.frolova@icandeliver.ru',
          },
        },
        {
          region: 'Москва и область – Урал',
          manager: { name: 'Дмитрий Шванов', phone: '79257923653', email: 'dshvanov@deliver.ru' },
        },
        {
          region: 'Москва и область – Спб',
          manager: {
            name: 'Данила Степанчук',
            phone: '79260142993',
            email: 'danila.stepanchyk@icandeliver.ru',
          },
        },
        {
          region: 'Спб и область - Урал / Сибирь',
          manager: {
            name: 'Кирилл Коробков',
            phone: '79260009935',
            email: 'kirill.korobkov@icandeliver.ru',
          },
        },
        {
          region: 'Юг - Урал / Сибирь',
          manager: {
            name: 'Александр Крыжановский',
            phone: '79251374862',
            email: 'alexander.kryzhanovsky@icandeliver.ru',
          },
        },
      ],
    };
  },

  computed: {
    ...mapGetters('configuration', ['getLanguages']),
  },

  mounted() {
    this.isEnterNumberLinkVisible = this.$route.meta.isEnterNumberLinkVisible;
    this.isRegistrationLinkVisible = this.$route.meta.isRegistrationLinkVisible;
    this.isForgotPasswordLinkVisible = this.$route.meta.isForgotPasswordLinkVisible;
  },

  watch: {
    $route(value) {
      this.isEnterNumberLinkVisible = value.meta.isEnterNumberLinkVisible;
      this.isRegistrationLinkVisible = value.meta.isRegistrationLinkVisible;
      this.isForgotPasswordLinkVisible = value.meta.isForgotPasswordLinkVisible;
    },

    // locale (val) {
    //   this.$i18n.locale = val.toLowerCase()
    // }
  },

  methods: {
    openAti() {
      window.open('https://ati.su/firms/1608942/info', '_blank');
    },
    // onLangChange (key) {
    //   this.locale = key
    // },
    formatNumber(number) {
      return `+${number[0]} ${number.slice(1, 4)} ${number.slice(4, 7)} ${number.slice(
        7,
        9,
      )} ${number.slice(9, 11)}`;
    },
  },
};
</script>
